import React, { useState, useEffect, useMemo } from "react";
import { BiPlus } from "react-icons/bi";
import CustomButton from "components/common/Button/CustomButton";
import SelectOption from "components/common/Select/Select";
import SideBar from "components/common/SideBar/SideBarNew";
import TableHeader from "components/common/Table/TableHeader";
import { LOADER_STATUS } from "Constants/constant";
import { LoginContext } from "helpers/LoginContext";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import NdisClaimNewTableItem from "./NdisClaimNewTableItem";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import NdisClaimNewModal from "./NdisClaimNewModal";
import Header from "components/common/Header/Header";
import Breadcrumb from "components/common/Breadcrumb";
import {
  COS_BREADCRUMB,
  COS_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import CheckBox from "components/common/checkBox/checkbox";
import useCareLabels from "hooks/useCareLabels";

const NdisClaimNew = (props) => {
  const {
    createClaim,
    getClientsRequest,
    getNdisClaimMode,
    clientsList,
    supportCoordinatorsRequest,
    getCaseNotesRequest,
    caseNotesListForClaim,
    supportCoordinator,
    caseNotesListForClaimLoader,
    clientsListLoader,
    addCaseNotesToListLoading,
    ndisClaimMode,
  } = props;

  const { sideBarPadding, isUserGracePeriodOver } =
    React.useContext(LoginContext);
  const { participantLabel } = useCareLabels();
  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);
  const [checkboxes, setCheckboxes] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [supportCoordiantion, setSupportCoordination] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [deliveredFromDate, setDeliveredFromDate] = useState(null);
  const [deliveredToDate, setDeliveredToDate] = useState(null);
  const [reportType, setReportType] = useState(null);
  const [amount, setAmount] = useState(0);
  const [quantity, setQuantity] = useState(0);

  const ndisClaimNewToMap = useMemo(() => {
    if (caseNotesListForClaim && caseNotesListForClaim.length > 0) {
      return caseNotesListForClaim;
    }
    return [];
  }, [caseNotesListForClaim]);

  const handleCheckboxChange = (e, id, item) => {
    const filteredList = checkboxes.filter((c) => c !== id);
    if (e) {
      filteredList.push(id);
      setAmount(() => parseFloat(amount) + parseFloat(item.total_amount));
      setQuantity(() => parseInt(quantity) + parseInt(item.quantity));
    } else {
      setAmount(() => parseFloat(amount) - parseFloat(item.total_amount));
      setQuantity(() => parseInt(quantity) - parseInt(item.quantity));
    }
    setCheckboxes(filteredList);
  };

  const toggleCheckboxes = (val) => {
    if (val) {
      const data = ndisClaimNewToMap.reduce((obj, data) => {
        Object.assign(obj, {
          totalAmount: obj["totalAmount"]
            ? obj["totalAmount"] + parseFloat(data.total_amount)
            : parseFloat(data.total_amount),
          totalQuantity: obj["totalQuantity"]
            ? obj["totalQuantity"] + parseFloat(data.quantity)
            : parseFloat(data.quantity),
        });
        return obj;
      }, {});
      setAmount(data?.totalAmount || 0);
      setQuantity(data?.quantity || 0);
      setCheckboxes(ndisClaimNewToMap.map((t) => t.id));
    } else {
      setCheckboxes([]);
      setAmount(0);
      setQuantity(0);
    }
  };

  useEffect(() => {
    if (
      ndisClaimNewToMap &&
      checkboxes &&
      checkboxes.length === ndisClaimNewToMap.length &&
      ndisClaimNewToMap.length !== 0
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }, [checkboxes]);

  useEffect(() => {
    getClientsRequest();
    supportCoordinatorsRequest();
    getNdisClaimMode();
    //   return () => emptyTableData();
  }, []);

  useEffect(() => {
    if (!caseNotesListForClaimLoader && renderLoading !== LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.COMPLATE);
    }
  }, [caseNotesListForClaimLoader]);

  useEffect(() => {
    setRenderLoading(LOADER_STATUS.PENDING);
    setCheckboxes([]);
    getCaseNotesRequest({
      pt_id: selectedClient ? selectedClient.value : "all",
      from_date: fromDate ? fromDate : "all",
      to_date: toDate ? toDate : "all",
      delivered_date_from: deliveredFromDate ? deliveredFromDate : "all",
      delivered_date_to: deliveredToDate ? deliveredToDate : "all",
      cos_id: supportCoordiantion ? supportCoordiantion.value : "all",
    });
    setAmount(0);
  }, [supportCoordiantion, fromDate, toDate, deliveredFromDate, deliveredToDate, selectedClient]);

  const handleOnCreateClaimList = () => {
    if (isUserGracePeriodOver) return;
    if (checkboxes && checkboxes.length > 0) {
      setIsModelOpen(true);
    }
  };

  useEffect(() => {
    if (reportType) {
      getCaseNotesRequest({
        pt_id: selectedClient ? selectedClient.value : "all",
        from_date: fromDate ? fromDate : "all",
        to_date: toDate ? toDate : "all",
        delivered_date_from: deliveredFromDate ? deliveredFromDate : "all",
        delivered_date_to: deliveredToDate ? deliveredToDate : "all",
        cos_id: supportCoordiantion ? supportCoordiantion.value : "all",
        report: reportType,
      });
      setReportType(null);
    }
  }, [reportType]);
  const [isOpenModel, setIsModelOpen] = useState(false);

  useEffect(() => {
    if (clientsList && clientsList) {
      clientsList.unshift({ label: "All", value: "all" });
    }
  }, [clientsList]);

  useEffect(() => {
    if (supportCoordinator && supportCoordinator) {
      supportCoordinator.unshift({ label: "All", value: "all" });
    }
  }, [supportCoordinator]);

  return (
    <>
      <div className='min-h-full min-w-0'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          } flex min-h-screen min-w-0 flex-col`}
        >
          <main className='flex w-full min-w-0 flex-1 flex-col bg-white pb-10'>
            <Header
              title='Create NDIS Claims'
              breadcrumb={
                <Breadcrumb
                  pages={COS_BREADCRUMB(
                    COS_BREADCRUMB_PAGES.CREATE_NDIS_CLAIMS
                  )}
                />
              }
            />
            <div className='w-full min-w-0 bg-white py-3'>
              <div
                className='relative z-[80] mx-auto flex w-full flex-col justify-between gap-4 bg-white px-4 py-2 sm:flex-row sm:items-end sm:px-8 lg:px-8 sticky'
                style={{ top: "80px" }}
              >
                <div className='flex flex-wrap gap-x-2 gap-y-2 w-[85%]'>
                  <div className='col-span-1 w-[20%] min-w-[10rem]'>
                    <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                      {participantLabel}
                    </label>
                    <SelectOption
                      isClearable={true}
                      isDisabled={
                        clientsListLoader || caseNotesListForClaimLoader
                      }
                      cssClass=''
                      name='client'
                      isSearch={false}
                      data={clientsList && clientsList}
                      selectedOption={selectedClient}
                      handleChange={(e) => {
                        setSelectedClient(e);
                      }}
                      // placeHolder="Participant Name"
                    />
                  </div>
                  <div className='col-span-1 w-[20%] min-w-[10rem]'>
                    <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                      Support Coordinator
                    </label>
                    <SelectOption
                      isClearable={true}
                      isDisabled={
                        clientsListLoader || caseNotesListForClaimLoader
                      }
                      cssClass=''
                      name='sp_cos_id'
                      isSearch={false}
                      data={supportCoordinator && supportCoordinator}
                      selectedOption={supportCoordiantion}
                      handleChange={(e) => {
                        setSupportCoordination(e);
                      }}
                    />
                  </div>
                  <div className='w-[22%] min-w-[12rem]'>
                    <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                      Created Date
                    </label>
                    <DateRangePickerNew
                      isDisabled={clientsListLoader}
                      handleCancel={() => {
                        setFromDate(null);
                        setToDate(null);
                      }}
                      handleChange={(obj) => {
                        if (obj && obj.fromDate && obj.toDate) {
                          setFromDate(obj.fromDate);
                          setToDate(obj.toDate);
                        }
                      }}
                      fromDate={fromDate}
                      toDate={toDate}
                    />
                  </div>
                  <div className='w-[22%] min-w-[12rem]'>
                    <label className='block text-start text-sm font-medium text-gray-700 text-start'>
                      Delivered Date
                    </label>
                    <DateRangePickerNew
                      isDisabled={clientsListLoader}
                      handleCancel={() => {
                        setDeliveredFromDate(null);
                        setDeliveredToDate(null);
                      }}
                      handleChange={(obj) => {
                        if (obj && obj.fromDate && obj.toDate) {
                          setDeliveredFromDate(obj.fromDate);
                          setDeliveredToDate(obj.toDate);
                        }
                      }}
                      fromDate={deliveredFromDate}
                      toDate={deliveredToDate}
                    />
                  </div>
                </div>

                <div className='mt-5'>
                  <CustomButton
                    clickHandler={handleOnCreateClaimList}
                    Icon={<BiPlus />}
                    label='Create Claim'
                    isDisabled={
                      (checkboxes.length === 0 ? true : false) ||
                      addCaseNotesToListLoading ||
                      isUserGracePeriodOver
                    }
                  />
                  {/* <Search setSearch={setSearch} search={search} /> */}
                </div>
              </div>
              <div className='sm:px-6 lg:px-8'>
                <div className='flex flex-col'>
                  <div className='min-w-0 py-2 align-middle'>
                    <div className='max-w-full overflow-x-auto overflow-y-visible rounded-lg border border-gray-200 shadow-sm ring-1 ring-black ring-opacity-5'>
                      <table className='w-full min-w-[1024px] table-fixed divide-y divide-gray-300'>
                          <thead className='bg-blue-50 capitalize'>
                            <tr>
                              <th
                                scope='col'
                                className='w-[3%] min-w-0 bg-blue-50 px-1 py-3.5 text-center text-sm font-semibold text-gray-900 sm:text-base'
                              >
                                <CheckBox
                                  isDisabled={isUserGracePeriodOver}
                                  checked={allSelected}
                                  handleChange={(e) => {
                                    if (isUserGracePeriodOver) {
                                      return;
                                    }
                                    if (
                                      ndisClaimNewToMap &&
                                      ndisClaimNewToMap.length > 0
                                    ) {
                                      setAllSelected(e);
                                      toggleCheckboxes(e);
                                    }
                                  }}
                                />
                              </th>

                              <TableHeader
                                isSort={false}
                                label={"Reference"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Support Item"}
                                innerCssClass='truncate'
                                cssClass='w-[12%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Support Item No."}
                                innerCssClass='truncate'
                                cssClass='w-[7%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Created By"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Created Date"}
                                innerCssClass='whitespace-normal break-words leading-tight'
                                cssClass='w-[6%] min-w-[4.5rem] bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 align-top sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={participantLabel}
                                innerCssClass='truncate'
                                cssClass='w-[11%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Mgmt Style"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Date Delivered"}
                                innerCssClass='truncate'
                                cssClass='w-[12%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Hours"}
                                innerCssClass='truncate'
                                cssClass='w-[5%] min-w-0 bg-blue-50 px-3 py-3.5 text-right text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Km"}
                                innerCssClass='truncate'
                                cssClass='w-[4%] min-w-0 bg-blue-50 px-3 py-3.5 text-right text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Rate"}
                                innerCssClass='truncate'
                                cssClass='w-[5%] min-w-0 bg-blue-50 px-3 py-3.5 text-right text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Total Value"}
                                innerCssClass='truncate'
                                cssClass='w-[8%] min-w-0 bg-blue-50 px-3 py-3.5 text-right text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <TableHeader
                                isSort={false}
                                label={"Status"}
                                innerCssClass='truncate'
                                cssClass='w-[6%] min-w-0 bg-blue-50 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:text-base'
                              />
                              <th className='w-[3%] min-w-0 bg-blue-50 px-1 py-3.5'>
                                <div className='sr-only'>View</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody className='divide-y divide-gray-200 bg-white'>
                            {(renderLoading === LOADER_STATUS.PENDING &&
                              caseNotesListForClaimLoader) ||
                            addCaseNotesToListLoading ? (
                              <tr>
                                <td colSpan={15} className='bg-gray-50 py-2'>
                                  <CircularLoader
                                    classes='flex justify-center items-center'
                                    classloader='loader-l'
                                  />
                                </td>
                              </tr>
                            ) : ndisClaimNewToMap &&
                              ndisClaimNewToMap.length > 0 ? (
                              ndisClaimNewToMap.map((item, index) => (
                                <NdisClaimNewTableItem
                                  isUserGracePeriodOver={isUserGracePeriodOver}
                                  checkboxes={checkboxes}
                                  handleCheckboxChange={(e) =>
                                    handleCheckboxChange(e, item.id, item)
                                  }
                                  item={item}
                                  key={index}
                                />
                              ))
                            ) : (
                              renderLoading !== LOADER_STATUS.NA &&
                              ndisClaimNewToMap.length === 0 && (
                              <tr>
                                <td
                                  colSpan={15}
                                  className='py-6 text-center text-red-600'
                                >
                                    No Data Found !
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {isOpenModel && (
        <NdisClaimNewModal
          checkboxes={checkboxes}
          createClaim={createClaim}
          amount={amount}
          quantity={quantity}
          openModel={isOpenModel}
          handleClose={setIsModelOpen}
          ndisClaimMode={ndisClaimMode}
        />
      )}
    </>
  );
};

export default NdisClaimNew;
